import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Avatar } from 'material-ui';
import {
  faToilet,
  faToiletPaper,
  faPumpMedical,
  faSprayCanSparkles,
  faSoap
} from '@fortawesome/free-solid-svg-icons';
import {
  PAPER_TOWEL,
  TOILET_PAPER,
  SOAP,
  AIR_FRESHENER,
  HAND_SANITIZER,
  TOILET_PRODUCT
} from '../../../../constants/MRSCategories';

const iconCategoryMap = {
  [PAPER_TOWEL]: {
    icon: faToiletPaper,
    transform: { rotate: -90 }
  },
  [TOILET_PAPER]: {
    icon: faToiletPaper,
    transform: {}
  },
  [SOAP]: {
    icon: faSoap,
    transform: {}
  },
  [AIR_FRESHENER]: {
    icon: faSprayCanSparkles,
    transform: {}
  },
  [HAND_SANITIZER]: {
    icon: faPumpMedical,
    transform: {}
  },
  [TOILET_PRODUCT]: {
    icon: faToilet,
    transform: {}
  }
};

const ItemIcon = (props) => {
  return (
    <Avatar>
      <FontAwesomeIcon
        icon={iconCategoryMap[props.item.subCategory]?.icon}
        size="lg"
        transform={iconCategoryMap[props.item.subCategory]?.transform}
      />
    </Avatar>
  );
};

export default ItemIcon;
